import React from "react";

// Shimmer placeholder blocks for admin loading states (replaces bare "Loading…").
export const SkeletonBar = ({ className = "" }) => (
  <div
    className={`animate-pulse rounded bg-theme-tertiaryBackground ${className}`}
  />
);

// A list of avatar + two-line rows (members, requests, conversations…).
export const SkeletonList = ({ rows = 5 }) => (
  <div className="flex flex-col gap-2.5">
    {Array.from({ length: rows }).map((_, i) => (
      <div
        key={i}
        className="flex items-center gap-3 rounded-xl border border-theme-chatDivider bg-theme-secondaryBackground p-3"
      >
        <SkeletonBar className="h-10 w-10 rounded-full" />
        <div className="flex-1">
          <SkeletonBar className="h-3 w-1/3" />
          <SkeletonBar className="mt-2 h-2.5 w-1/2" />
        </div>
      </div>
    ))}
  </div>
);

// A grid of stat/config cards.
export const SkeletonCards = ({ count = 4, cols = "sm:grid-cols-4" }) => (
  <div className={`grid grid-cols-2 gap-3 ${cols}`}>
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground p-4"
      >
        <SkeletonBar className="h-3 w-1/2" />
        <SkeletonBar className="mt-3 h-6 w-1/3" />
      </div>
    ))}
  </div>
);

// A stack of full-width block cards (forms, panels).
export const SkeletonBlocks = ({ count = 3 }) => (
  <div className="flex flex-col gap-4">
    {Array.from({ length: count }).map((_, i) => (
      <div
        key={i}
        className="rounded-2xl border border-theme-chatDivider bg-theme-secondaryBackground p-5"
      >
        <SkeletonBar className="h-3 w-1/4" />
        <SkeletonBar className="mt-3 h-2.5 w-3/4" />
        <SkeletonBar className="mt-2 h-2.5 w-2/3" />
      </div>
    ))}
  </div>
);
